import axiosInstance from 'src/utils/axiosInstance';
import UrlConstants from 'src/constants/urlConstants';

const PREFILL_QUOTES_PATH = UrlConstants().PREFILL_QUOTES;

export const sendCustomerFiscalNumber = ({ clientId }) => {
  return axiosInstance.post(PREFILL_QUOTES_PATH, { clientId });
};
